import { render, staticRenderFns } from "./cooperationFrameworkProtocolNobl.vue?vue&type=template&id=4455f58e&scoped=true"
import script from "./cooperationFrameworkProtocolNobl.vue?vue&type=script&lang=js"
export * from "./cooperationFrameworkProtocolNobl.vue?vue&type=script&lang=js"
import style0 from "./cooperationFrameworkProtocolNobl.vue?vue&type=style&index=0&id=4455f58e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4455f58e",
  null
  
)

export default component.exports